import { render, staticRenderFns } from "./MetaSets.vue?vue&type=template&id=c0f13980&"
import script from "./MetaSets.vue?vue&type=script&lang=js&"
export * from "./MetaSets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports